// extracted by mini-css-extract-plugin
export var active = "_en-7";
export var container = "_en-0";
export var evenWidth = "_en-4";
export var large = "_en-5";
export var outlet = "_en-8";
export var slide = "_en-2";
export var small = "_en-6";
export var tab = "_en-3";
export var tabs = "_en-1";